import * as React from "react";
import { useDispatch } from "@teamprevent/admin-redux";
import { Button, Divider, Form, Modal } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";
import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";

import { unableToBookVideoAppointmentsReasonsOptions } from "../model";
import { ActiveTaskAction } from "../../task/taskActions/ActiveTaskAction";
import { UNABLE_TO_BOOK_VIDEO_APPOINTMENT } from "../actionTypes";
import { markVideoConsultationAsUnableToBook } from "../actions";

interface Props {
    task: TaskModel;
}

export const UnableToBookVideoConsultationButton: React.FunctionComponent<Props> = (props: Props) => {

    const [modalOpen, setModalOpen] = React.useState<boolean>(false);
    const [submitted, setSubmitted] = React.useState<boolean>(false);
    const [reason, setReason] = React.useState<string>(null);
    const [comments, setComments] = React.useState<string>(null);

    const onUnableToBook = () => {
        setModalOpen(true);
    };

    const onUnableToBookCancel = () => resetState();

    const resetState = () => {
        setModalOpen(false);
        setSubmitted(false);
        setReason(null);
        setComments(null);
    };

    const dispatch = useDispatch();
    const onUnableToBookCancelConfirm = () => {
        setSubmitted(true);
        if (!reason) {
            return;
        }

        setModalOpen(false);
        const justification = unableToBookVideoAppointmentsReasonsOptions.find(o => o.value === reason).text + (comments ? ": " + comments : "");
        dispatch(markVideoConsultationAsUnableToBook(props.task.caseId, props.task.id, justification));
    };

    const onReasonChange = (newReason: string) => {
        setReason(newReason);
    };

    const onCommentsChange = (newComments: string) => {
        setComments(newComments);
    };

    return (
        <ActiveTaskAction task={props.task}>
            <Modal open={modalOpen}>
                <Modal.Header content="Unable to Book Video" />
                <Modal.Content>
                    <Form>
                        <Input.Dropdown
                            required
                            value={reason}
                            showErrors={submitted}
                            label="Reason"
                            options={unableToBookVideoAppointmentsReasonsOptions}
                            onChange={onReasonChange}
                        />
                        <Divider hidden />
                        <Input.Textarea
                            value={comments}
                            label="Comments"
                            onChange={onCommentsChange}
                        />
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button content="Cancel" onClick={onUnableToBookCancel} />
                    <Button content="Confirm" onClick={onUnableToBookCancelConfirm} />
                </Modal.Actions>
            </Modal>
            <IsLoadingButton
                content="Unable to Book Video"
                floated="right"
                onClick={onUnableToBook}
                requestNames={`${UNABLE_TO_BOOK_VIDEO_APPOINTMENT}_${props.task.id}`}
            />
        </ActiveTaskAction>
    );
};
